var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AutoComplete',{attrs:{"size":_vm.size,"data":_vm.sdata,"transfer":"","capture":"","filter-method":_vm.handleFilter,"clearable":"","placeholder":_vm.placeholder || '请输入'},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }